// firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAxeTLYJS6ViRO8ulLzS5XK0QPxYslGAZg",
  authDomain: "metin2tools-569c4.firebaseapp.com",
  projectId: "metin2tools-569c4",
  storageBucket: "metin2tools-569c4.firebasestorage.app",
  messagingSenderId: "737041940736",
  appId: "1:737041940736:web:5a3ea726ed6e5dc81cf3e5"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
